import { EcranSaisieClient } from '@innovpaie/openpaye-moteur/saisie-client-ui';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { APP_CONFIG } from '@/constants/app';
import { collecteService } from '../services/collecte.service';

/**
 * La gestionnaire saisit À LA PLACE du client (il a envoyé son Excel par mail)
 * — le MÊME écran que celui du client, ouvert depuis la collecte du mois.
 */
export function PageSaisiePourLeCabinet() {
  const { folderUuid = '' } = useParams();
  const [parametres] = useSearchParams();
  const naviguer = useNavigate();
  const mois = Number(parametres.get('mois')) || new Date().getMonth() + 1;
  const annee = Number(parametres.get('annee')) || new Date().getFullYear();
  return (
    <EcranSaisieClient
      baseUrl={APP_CONFIG.api.baseUrl}
      cabinet={{
        folderUuid,
        mois,
        annee,
        formulaire: () => collecteService.formulaire(folderUuid, mois, annee),
        saisirPourLeClient: lignes =>
          collecteService.saisirPourLeClient(folderUuid, mois, annee, lignes as never),
        retour: () => naviguer(-1),
      }}
    />
  );
}
